import { useState, useRef } from 'react'
import useTranslate from 'common/hooks/use-translate'

function normalizeValue(value) {
  return typeof value === 'number' ? String(value) : value || ''
}

function useForm(initialValues = {}) {
  const { current: initialValidation } = useRef({})
  const translate = useTranslate()
  const [values, setValues] = useState(initialValues)
  const [errors, setErrors] = useState({})
  const [touched, setTouched] = useState({})

  function field(field, validate) {
    function checkForErrors(value) {
      const error = validate ? validate(normalizeValue(value)) : false

      setErrors(errors => ({
        ...errors,
        [field]: error
      }))
    }

    function onChange(value) {
      checkForErrors(value)
      setValues(values => ({
        ...values,
        [field]: value
      }))
    }

    function onBlur() {
      checkForErrors(values[field])
      setTouched(touched => ({
        ...touched,
        [field]: true
      }))
    }

    const hasError = Boolean(touched[field] && errors[field])

    if (!initialValidation[field]) {
      initialValidation[field] = true
      checkForErrors(values[field])
    }

    return {
      name: field,
      value: normalizeValue(values[field]),
      error: hasError,
      fieldTooltip: hasError ? translate(errors[field]) : undefined,
      onChange,
      onBlur
    }
  }

  return {
    field,
    values,
    hasError: Boolean(Object.values(errors).find(Boolean))
  }
}

export default useForm
